<template>
  <div class="detail">
    <section class="detail-header">
      <div class="bg"></div>
      <div class="content">
        <div class="cover-wrap">
          <img :src="imgAddress" alt />
        </div>
        <div class="content-right">
          <h3>{{info.subject}}{{info.teachBook}}</h3>
          <p>{{info.grade}}{{info.schoolYear}}学期</p>
        </div>
      </div>
    </section>
    <section class="detail-content">
      <div
        v-for="(item, index) in chapterList"
        class="chapter"
        :class="{'mb-0':index==chapterList.length-1}"
        :key="index"
      >
        <h3>{{item.chapterName}}</h3>
        <ul>
          <li v-for="(im, index) in item.items" :key="index">
            <template v-if="im.status == -1">
              <div class="title clearfix">
                <h2>{{item.chapterIndex}}.{{im.chapterIndex}} {{im.chapterName}}</h2>
                <p>未作答</p>
              </div>
            </template>
            <template v-else>
              <div class="title clearfix">
                <h2
                  :class="{'mt-20': im.status==0}"
                >{{item.chapterIndex}}.{{im.chapterIndex}} {{im.chapterName}}</h2>
                <span v-if="im.status==0">答题量较少，得分仅供参考</span>
              </div>
              <div class="unit">
                <p class="num">答题数量：{{im.questions}}</p>
                <p>总体正确率：{{ im.questions==0 ? 0 : ((im.right/im.questions)*100)}}%</p>
                <div class="score">
                  <i>{{ parseInt(im.questions) == 0 ? 0 : im.score}}</i>分
                  <span v-if="im.status==3" class="good">优秀</span>
                  <span v-if="im.status==2" class="ok">良好</span>
                  <span v-if="im.status==1" class="bad">薄弱</span>
                </div>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import ajax from "@/api/ajax";
import utils from "@/assets/js/utils";
import rj11 from "../../assets/images/bookcover/11.png";
import rj12 from "../../assets/images/bookcover/12.png";
import rj21 from "../../assets/images/bookcover/21.png";
import rj22 from "../../assets/images/bookcover/22.png";
import rj31 from "../../assets/images/bookcover/31.png";
import rj32 from "../../assets/images/bookcover/32.png";
import rj41 from "../../assets/images/bookcover/41.png";
import rj42 from "../../assets/images/bookcover/42.png";
import rj51 from "../../assets/images/bookcover/51.png";
import rj52 from "../../assets/images/bookcover/52.png";
import rj61 from "../../assets/images/bookcover/61.jpg";
import rj62 from "../../assets/images/bookcover/62.png";
const gradeConfig = {
  一年级上: rj11,
  一年级下: rj12,
  二年级上: rj21,
  二年级下: rj22,
  三年级上: rj31,
  三年级下: rj32,
  四年级上: rj41,
  四年级下: rj42,
  五年级上: rj51,
  五年级下: rj52,
  六年级上: rj61,
  六年级下: rj62
};
export default {
  name: "about",
  data() {
    return {
      chapterList: [],
      info: {},
      imgAddress: "",
      token: "",
      date: ""
    };
  },
  methods: {
    getList: async function() {
      const _this = this;
      const [resp] = await ajax.all([
        ajax.get("/parent/mastery/mastery-info", {
          params: {
            token: _this.token,
            date: _this.date
          }
        })
      ]);
      if (resp.data.code == 99999) {
        if (Array.isArray(resp.data.data)) {
          return;
        }
        _this.chapterList = resp.data.data.items.items;
        _this.info = resp.data.data.info;
        _this.imgAddress =
          gradeConfig[_this.info.grade + _this.info.schoolYear];
      }
    },
    setToken: async function() {
      let self = this;
      self.token = utils.getQueryString("token");
      self.date = utils.getQueryString("date");
    }
  },
  created: async function() {
    let self = this;
    await self.setToken();
    utils.sendLog(
      {
        token: self.token,
        version: "3.0.9",
        source: "h5"
      },
      "jz0164"
    );
    await self.getList();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/font/font.scss";
.detail {
  &-header {
    height: 3.28rem;
    background: #fff;
    position: relative;
    .bg {
      height: 2.62rem;
      background-color: #f3dec7;
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 10;
    }
    .content {
      margin-top: 0.4rem;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 20;
      padding: 0 0.63rem;
      .cover-wrap {
        width: 2.08rem;
        height: 2.88rem;
        background-color: #fff;
        box-shadow: 0 0.08rem 0.2rem 0 rgba(0, 0, 0, 0.08);
        border-radius: 0.16rem;
        float: left;
        text-align: center;
        img {
          width: 1.88rem;
          height: 2.68rem;
          display: inline-block;
          margin: 0.1rem auto;
          background-color: #dcdcdc;
          box-shadow: 0 0.08rem 0.2rem 0 rgba(0, 0, 0, 0.08);
          border-radius: 0.1rem;
        }
      }
      &-right {
        float: left;
        text-align: left;
        margin-left: 0.28rem;
        width: 3.85rem;
        h3 {
          font-size: 0.36rem;
          color: #b37f51;
          margin-top: 0.65rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-family: PingFangSC-Medium;
        }
        p {
          font-size: 0.24rem;
          color: #b37f51;
          margin-top: 0.16rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-family: PingFangSC-Regular;
        }
      }
    }
  }
  &-content {
    background-color: #f5f5f5;
    padding-bottom: 0.18rem;
    .chapter {
      margin-bottom: 0.18rem;
      background: #fff;
      h3 {
        font-size: 0.36rem;
        color: #56586a;
        margin: 0 0.3rem 0.4rem 0.3rem;
        padding-top: 0.34rem;
        font-family: PingFangSC-Medium;
        font-weight: bold;
      }
      ul {
        border-top: 1px solid #eee;
        li {
          border-bottom: 1px solid #eee;
          padding: 0.3rem;
          .title {
            h2 {
              font-size: 0.34rem;
              color: #8487a0;
              float: left;
              font-family: PingFangSC-Medium;
              font-weight: bold;
            }
            .mt-20 {
              margin-bottom: 0.2rem;
            }
            span {
              float: right;
              font-size: 0.22rem;
              color: #fff;
              background: #d1d1d1;
              opacity: 0.6;
              padding: 0.06rem 0.1rem;
            }
            p {
              float: right;
              font-size: 0.24rem;
              margin-top: 0.1rem;
              color: #ccc;
              padding-left: 0.36rem;
              height: 0.28rem;
              line-height: 0.34rem;
              background: url("../../assets/images/lock-logo.png") 0 0/0.24rem
                0.28rem no-repeat;
            }
          }
          .unit {
            position: relative;
            padding: 0.25rem 0 0 0.55rem;
            p {
              font-size: 0.28rem;
              color: #8487a0;
              font-family: PingFangSC-Regular;
            }
            p.num {
              margin-bottom: 0.25rem;
            }
            .score {
              position: absolute;
              right: 0;
              bottom: -0.15rem;
              color: #f5833d;
              font-size: 0.24rem;
              padding-right: 0.8rem;
              i {
                color: #f5833d;
                font-size: 0.76rem;
                font-family: "DINCB";
              }
              span {
                position: absolute;
                right: 0;
                top: 0;
                border-radius: 0.2rem;
                color: #fff;
                font-size: 0.22rem;
                padding: 0.03rem 0.18rem;
              }
              span.good {
                background-color: #ff6c5e;
              }
              span.ok {
                background-color: #f2a024;
              }
              span.mid {
                background-color: #8fb804;
              }
              span.bad {
                background-color: #9d9999;
              }
            }
          }
        }
      }
    }
    .chapter.mb-0 {
      margin-bottom: 0;
    }
  }
}
</style>
